import type { DomainEvent } from "@e308/core";
import type { MatchLogPayload } from "./diplomacy-types.js";
import type { ConflictEvent } from "./types.js";

export function toConflictEvent(event: DomainEvent): ConflictEvent {
  if (event.type === "match-log")
    return Object.freeze({
      sequence: event.sequence,
      atGameMs: event.atGameMs,
      ...(event.payload as MatchLogPayload),
    }) as ConflictEvent;
  const payload = event.payload as {
    readonly seatId?: string;
    readonly borderId?: string;
    readonly fightingStartsAtMs?: number;
    readonly outcome?: "seat-win" | "team-win" | "draw";
    readonly winnerId?: string;
  };
  const kind = event.type as ConflictEvent["kind"];
  if (
    ![
      "shield-breached",
      "seat-eliminated",
      "new-border",
      "overtime-started",
      "match-ended",
    ].includes(event.type)
  )
    throw new TypeError(`Unknown conflict event: ${event.type}`);
  return Object.freeze({
    sequence: event.sequence,
    atGameMs: event.atGameMs,
    kind,
    ...(payload.seatId ? { seatId: payload.seatId } : {}),
    ...(payload.borderId ? { borderId: payload.borderId } : {}),
    ...(payload.fightingStartsAtMs !== undefined
      ? { fightingStartsAtMs: payload.fightingStartsAtMs }
      : {}),
    ...(payload.outcome ? { outcome: payload.outcome } : {}),
    ...(payload.winnerId ? { winnerId: payload.winnerId } : {}),
  }) as ConflictEvent;
}
